"use client";

import React from "react";
import LinkItem from "./LinkItem";

type Props = {
  logoSrcLinkPath: string;
};

const LeftContainer: React.FC<Props> = ({ logoSrcLinkPath }) => {
  return (
    <div className="flex items-center">
      <LinkItem path={logoSrcLinkPath} className="w-full p-0" disableHover>
        {/* Logo icon for < lg */}
        <img
          src="/assets/logos/gondola.svg"
          alt="Gondola"
          className="block h-[40px] w-[40px] lg:hidden"
          width={64}
          height={63}
          loading="lazy"
        />
        {/* Logo text for >= lg */}
        <img
          src="/assets/logos/gondola-logo-text.svg"
          alt="Gondola"
          className="hidden h-[33px] w-full md:h-[40px] lg:block"
          width={300}
          height={51}
          loading="lazy"
        />
      </LinkItem>
    </div>
  );
};

export default LeftContainer;
